import React, {useState, useRef, useEffect, useCallback} from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';

import { useForm, Controller } from 'react-hook-form';

import { ImageLoader } from '../../imageloader';
import { URL_APLICATION } from '../../../services/api';

import { addCartItem, getCartList } from '../../../services/shoppingcart';

import { useAPP } from '../../../services/provider/app';

import { formatToMoney } from '../../../services/utils';



import {ic_local_dining} from 'react-icons-kit/md/ic_local_dining';

import '../../../assets/style/components/cards/product/index.scss';

export const CardProduct = (props) => {


    let defaultValues = {
        description:''
    };

    (props.combo || []).map(item => {

        defaultValues[`combo_${item.id}`] = 0;

        return item;
    })

    const form = useForm({ defaultValues });
    const control =  form.control;
    const reset = form.reset;
    const handleSubmit = form.handleSubmit;

    const [showDialog, setShowDialog] = useState(false);
    const [total, setTotal] = useState(props.preco);
    const [quantity, setQuantity] = useState(1);

    const image = useRef(<ImageLoader image={`${URL_APLICATION}${props.icone_pedidoweb}`} default={ic_local_dining} />);
    const formData = useRef();

    const toast = useRef(null);

    const { setVersion } = useAPP();

    const getComboName = () => {
        return [...new Set(props.combo.map(item => item.nome_combo))]
    }

    const getItemsMyComboName = (_combo) => {
        return props.combo.filter(item => (new RegExp(item.nome_combo, 'gi').test(_combo)));
    }

    const updatePrice = useCallback(() => {

        const listItensData = form.getValues()

        const listItens =  Object.keys(listItensData).filter(item => (/combo/gi).test(item));
        
        const aditionalItems = listItens.reduce((_c, _n)=>{
            const _total = ~~listItensData[_n];
            const _item = (props.combo || []).filter(item => ~~item.id === ~~(_n.toString().replace(/\D/gi,'')))[0];
            const _price = _item ? parseFloat(_item.valor_unitario) : 0;
            return _c + (_total * _price);

        }, 0);

        setTotal((quantity * props.preco) + (quantity * aditionalItems) - (quantity * parseFloat(props.desconto)));
    }, [quantity, props, form])

    const setStarted = () => {
        reset();
        setQuantity(1);
    }

    const onSubmit = (_data) => {
        console.log(_data);

        const listItens =  Object.keys(_data).filter(item => (/combo/gi).test(item));

        let database = {
            id: props.id,
            name: props.produto,
            price: props.preco,
            descont: props.desconto,
            quantity: quantity,
            description: _data.description,
            combo: null
        }

        if(props.combo){
            database.combo = listItens.map(el => {                
                const _total = ~~_data[el];
                const _item = props.combo.filter(item => ~~item.id === ~~(el.toString().replace(/\D/gi,'')))[0];
                if(_total > 0){
                    return {
                        id: _item.id,
                        name: _item.produto,
                        price: _item.valor_unitario,
                        quantity: _total

                    };
                }
                return el;
            })

            database.combo = database.combo.filter(item => item !== undefined);
        }

        //console.log('Add');
        //console.dir(database);
        addCartItem(database);
        setVersion(getCartList().length);

        setShowDialog(false);

        toast.current.show({severity: 'success', summary: 'Sucesso', detail: <>Item adicionado com sucesso. <Button onClick={()=> props.history.push(`/${props.match.params.client}/user/cart`)} label="Ir para carrinho" className="p-button-text p-button-sm" /></>});

    }

    const getCardType = () => {
        const cartTypes = {
            product: 'card-product',
            promotional: 'card-promotional'
        }

        let type = cartTypes.product;


        if(cartTypes[props.type])
            type = cartTypes[props.type];

        return type;
    }

    useEffect(()=>{

        updatePrice();

    }, [quantity, updatePrice]);

    return (
        <div className={`${getCardType()} p-shadow-2`}>
            <div className="area-image">
                {image.current}
            </div>
            <div className="product-name">
                {props.produto}
            </div>
            <div className="product-description">
                {props.detalhes}
            </div>
            <div className="product-price">
                {
                    parseFloat(props.desconto) > 0 ?
                    <><del style={{fontSize:'0.8em'}}>{formatToMoney(props.preco)}</del> <strong> { formatToMoney(parseFloat(props.preco) -  parseFloat(props.desconto))}</strong> </>
                    :
                        formatToMoney(props.preco)
                }
            </div>
            <div className="product-action">
                {
                    (/product/gi).test(getCardType()) ?
                        <Button onClick={()=>{ setStarted(); setShowDialog(true);}} className="" icon="pi pi-shopping-cart" />
                    :
                        <Button onClick={()=>{ setStarted(); setShowDialog(true);}} style={{width:'100%'}} className="p-button-warning" icon="pi pi-shopping-cart" />
                }
            </div>
            <Dialog header="Adicionar ao carrinho" visible={showDialog} style={{ width: '950vw', maxWidth: '600px' }} footer={()=><>
                    
                    <div className="p-d-flex p-m-4 p-ai-center">
                        <div className="p-col">
                            <InputNumber decrementButtonClassName="p-button-sm" incrementButtonClassName="p-button-sm" min="1" value={quantity} onChange={(e)=> setQuantity(e.value)} size="3" showButtons  />
                        </div>
                        <div className="p-col-4">
                            <strong>Total</strong>: {formatToMoney(total)}    
                        </div>
                    </div>
                    <div className="p-d-flex p-jc-end">
                        <div className="p-col-fixed" style={{width:'250px'}}>
                            <Button onClick={()=>setShowDialog(false)} style={{width:'100px'}} label="Cancelar" className="p-button-danger p-mr-2 p-ml-3" />
                            <Button onClick={handleSubmit(onSubmit)} style={{width:'100px'}} label="Adicionar" className="p-button" />
                        </div>
                    </div>
                </>
            } onHide={() => setShowDialog(false)}>
                <form ref={formData} onSubmit={handleSubmit(onSubmit)}>
                    <div className="p-grid">
                        <div className="p-col-3">
                                {image.current}
                        </div>
                        <div className="p-col-9">
                            <h2>{props.produto}</h2>
                            <div>
                                {props.detalhes}
                            </div>
                        </div>
                    </div>
                    {
                        props.combo ?
                            <>
                                <Divider>
                                    <strong>Itens adicionais</strong>
                                </Divider>
                                {
                                    getComboName().map((item, id) => {
                                    return <div key={`item-add-${id}`} className="p-m-4">
                                            <h3>{item}</h3>
                                            {getItemsMyComboName(item).map(product => {
                                                return <div key={`item-add-product-${product.id}`} className="p-grid">
                                                    <div className="p-col-9">
                                                        <div><strong style={{fontSize:'0.8em'}}>{product.produto}</strong></div>
                                                        <div style={{fontSize:'0.8em'}}>
                                                            {formatToMoney(product.valor_unitario)}
                                                        </div>
                                                    </div>
                                                    <div className="p-col-3">
                                                        <Controller name={`combo_${product.id}`} control={control} defaultValue={0} render={({ field, fieldState }) => (
                                                            <InputNumber  id={field.name} value={field.value} onChange={(e)=>{field.onChange(e.value); updatePrice(); }} decrementButtonClassName="p-button-sm" incrementButtonClassName="p-button-sm" min="0" max={~~product.qtde_acrescimos} size="2" showButtons  />
                                                        )} />
                                                    </div>
                                                </div>
                                            })}
                                        </div>
                                    })
                                }
                            </>
                        :
                        ''
                    }
                    <Divider>
                        <strong>Informações adicionais</strong>
                    </Divider>
                    <Controller name={`description`} control={control}  render={({ field, fieldState }) => (
                        <InputTextarea style={{width: '100%'}} id={field.name} value={field.value} onChange={(e)=> field.onChange(e.target.value)} autoResize={true} rows={2} cols={30} placeholder="Exemplo: Retirar item, trocar item" />
                    )} />
               </form>
            </Dialog>
            <Toast ref={toast} position="bottom-center" />
        </div>
    )
}